import Router from "vue-router";

type Dictionary<T> = { [k:string]:T }

export const openRouterTab = (router:Router, name:string, params:Dictionary<string>) => {
	window.open((router.resolve({ name, params })).href, "_blank");
}